<template>
  <div class="single-color">
    <div class="wrapper" v-for="response in choices" :key="response.value">
      <vv-radio-color
        :value="response.value"
        :label="response.label"
        name="color"
        :modelValue="value"
        :color="response.value"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { VvRadioColor } from '@/components/common'

export default {
  name: 'Color',
  components: { VvRadioColor },
  props: {
    expectedResponse: {
      type: Object,
      required: true,
      validator(value) {
        if (!value.hasOwnProperty('choice')) return false

        return typeof value.choice === 'number'
      }
    },
    choices: {
      type: Array,
      required: true,
      validator(value) {
        return Array.isArray(value) && value.length > 0
      }
    },
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    handleChange(value) {
      const valueIndex = this.choices.findIndex(choice => choice.value === value)
      const correct = this.expectedResponse.choice === valueIndex

      this.$emit('change', { value, correct })
    }
  }
}
</script>

<style lang="scss" scoped>
.single-color {
  margin: auto;
  text-align: center;

  .wrapper {
    display: inline-block;
    width: 40%;
  }
}
</style>
